export default "__VITE_ASSET__CRsu8JVI__"